import React from 'react';
import icCarolus from '../../assets/logo_rs.png';
import icMed from '../../assets/medapp.png';
import icMedKecil from '../../assets/icon-medapp.png';
import logoKwitansi from '../../assets/logokwitansi.png';
import { Typography } from '@material-ui/core';
import QRCode from "react-qr-code";
import Constant from '../../library/Constant';
import { format } from 'date-fns';
import { getAge } from '../../library/Util';

export class ComponentGC extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      visibleRegis: true,
      strDate: '',
      strTime: ''
    }
  }

  componentDidMount() {
    console.log(this.props);
   
    this.tick()
    this.getDate()
  }

  getDate() {
    var date = new Date();
    var tahun = date.getFullYear();
    var bulan = date.getMonth();
    var tanggal = date.getDate();
    var hari = date.getDay();
    switch (hari) {
      case 0: hari = "Minggu"; break;
      case 1: hari = "Senin"; break;
      case 2: hari = "Selasa"; break;
      case 3: hari = "Rabu"; break;
      case 4: hari = "Kamis"; break;
      case 5: hari = "Jum'at"; break;
      case 6: hari = "Sabtu"; break;
    }
    switch (bulan) {
      case 0: bulan = "Jan"; break;
      case 1: bulan = "Feb"; break;
      case 2: bulan = "Mar"; break;
      case 3: bulan = "Apr"; break;
      case 4: bulan = "Mei"; break;
      case 5: bulan = "Jun"; break;
      case 6: bulan = "Jul"; break;
      case 7: bulan = "Agu"; break;
      case 8: bulan = "Sep"; break;
      case 9: bulan = "Okt"; break;
      case 10: bulan = "Nov"; break;
      case 11: bulan = "Des"; break;
    }
    let strDate = tanggal + '-' + bulan + '-' + tahun
    this.setState({ strDate })
  }

  tick() {
    this.setState({
      jam: new Date().getHours(),
      menit: new Date().getMinutes()
    }, () => {
      var ampm = this.state.jam >= 12 ? 'PM' : 'AM';
      this.state.jam = this.state.jam % 12;
      this.state.jam = this.state.jam ? this.state.jam : 12; // the hour '0' should be '12'
      this.state.menit = this.state.menit < 10 ? '0' + this.state.menit : this.state.menit;
      var strTime = this.state.jam + ':' + this.state.menit;
      this.setState({
        strTime
      })
    });
  }

  render() {
    return (
      <div dangerouslySetInnerHTML={{ __html: this.props.dataContent }} />
    );
  }
}